import * as yup from "yup";

export const validationSchema = yup.object({
    companyCode: yup.string().required("This field is required"),
    contractNo: yup.string().required("This field is required"),
});
